import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/enum';
import type {
  IdParam,
  JsonArray,
  JsonOrFormBody,
  JsonRecord,
} from './types/api-payloads.types';
import type { ChangePasswordBody, UpdateUserProfileBody } from './types/user-role-payloads.types';

@Injectable({
  providedIn: 'root',
})
export class CommonPagesUserRoleService {
  constructor(private _cS: CommonService) {}

  getRoles() {
    return this._cS.API_GET(EndPoints.GetAllRoles);
  }
  getUserProfileData() {
    return this._cS.API_GET(EndPoints.GetPaybevUserDetails, false);
  }

  updateProfileData(profileData: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateProfileData, profileData, false);
  }

  checkUniqueUser(userBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.UniqueUser, userBody, false);
  }
  getSelectedUserDetails(userId: IdParam) {
    return this._cS.API_GET(
      EndPoints.getSpecificUserDetails + `?UserId=${userId}`
    );
  }
  getUserDetails(userId: IdParam) {
    return this._cS.API_GET(EndPoints.GetUserDetailsById + `/${userId}`);
  }
  GetAccountSitesByAgency(userBody: JsonRecord | JsonArray) {
    return this._cS.API_POST(EndPoints.GetAccountSitesByAgency, userBody);
  }
  fileUpload(userBody: FormData) {
    return this._cS.API_POSTFileUpload(EndPoints.uploadFile, userBody);
  }
  fileDelete(userBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.deleteFile, userBody);
  }

  createRole(roleBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddRole, roleBody);
  }
  updateRole(roleBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.UpdateRole, roleBody);
  }
  getRoleById(roleId: string) {
    return this._cS.API_GET(EndPoints.GetRoleById + `/${roleId}`, false);
  }
  getPermissionsByRole(roleName: string) {
    return this._cS.API_GET(
      EndPoints.GetPermissionsByRole + `?RoleName=${roleName}`
    );
  }
  updatePermissionsByRole(permissionsBody: JsonRecord) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.UpdatePermissions,
      permissionsBody,
      true,
      { headers: hd }
    );
  }

  updateEmailDefaultByRole(permissionsBody: JsonRecord) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(
      EndPoints.UpdateEmailDefaults,
      permissionsBody,
      true,
      { headers: hd }
    );
  }

  createUser(userBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.AddUser, userBody);
  }
  EditUser(userBody: JsonRecord) {
    return this._cS.API_POST(EndPoints.EditUser, userBody);
  }

  changePassword(requestBody: ChangePasswordBody) {
    return this._cS.API_POST(EndPoints.ChangePassword, requestBody, false);
  }

  UpdateUserProfile(userBody: JsonOrFormBody | UpdateUserProfileBody) {
    const hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.UpdateUserProfile, userBody, false, {
      headers: hd,
    });
  }

  manageProfilePicture(formData: FormData) {
    return this._cS.API_POSTFileUpload(EndPoints.UploadProfilePicture, formData);
  }

  validateToken() {
    return this._cS.API_GET(EndPoints.ValidateToken);
  }

  validateSsoToken(token: string, email: string) {
    const body = { email };
    return this._cS.API_POST(EndPoints.ValidateSsoToken, body, false);
  }
}
